module.exports = __webpack_public_path__ + "scripts/favicon.ico?77ce5ca2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon.ico
// module id = 937
// module chunks = 1